import { Component, ElementRef, ViewChild } from '@angular/core';
import { FileOpener } from '@ionic-native/file-opener';
import { Screenshot } from '@ionic-native/screenshot';
import { SocialSharing } from '@ionic-native/social-sharing';
import { DatePipe } from '@angular/common';
import { ActionSheetController, AlertController, IonicPage, ModalController, NavController, NavParams, ViewController, LoadingController, Events } from 'ionic-angular';
import { ApiProvider } from '../../providers/api/api';
// import { TabsPage } from '../tabs/tabs';
import { File } from '@ionic-native/file';
import QRCode from 'qrcode';
// import { SearchPage } from '../search/search';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Camera, CameraOptions } from '@ionic-native/camera';
import { SubscriptionPage } from '../subscription/subscription';
/**
 * Generated class for the ProfilePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-profile',
  templateUrl: 'profile.html',
})
export class ProfilePage {
  @ViewChild('userInputt') userInputtViewChild: ElementRef;
  userInputElementt: HTMLInputElement;
  code = 'some sample string';
  codes: any = "{'hello':'name', 'bolo':'get', 'test':'fuckOff' }";
  // public vCard: VCard = {
  //   name: {
  //     firstNames: "John",
  //     lastNames: "Doe",
  //   },
  // };
  pakagechapterdetails: any;
  highlighted: any = -1;
  loading: any;
  generated = '';
  screen: any;
  vCardDAta: string = '';
  state: boolean = false;
  shared: boolean = false;
  pet: any;
  shareImageNi: any;
  vCardInfo: string;
  siteName: any;
  totalcr: number;
  mobiledescription: string;
  first_img: string;
  price: string;
  playstorurl: string;
  profilepackage: any;
  item = [{
    'name': 'Agatha Harkness',
    'played by': 'www.hscodes',
    'Fictional universe': 'Marvel Universe',
    'Creator': 'Stan Lee'
  }]

  qrInfo = JSON.stringify(this.item);
  elementType = 'url';
  value = 'Techiediaries';
  title = 'QrCode';
  qrJson: any;
  data: string;
  hideind: boolean;
  ngOnInit() {
    this.qrJson = {
      "Id": "12121",
      "Name": "ABCD",
      "Email": "abcd@gmail.com"
    }
    this.data = JSON.stringify(this.qrJson);


  }
  profiledata: any = [];
  pakagedetails: any = [];
  shownGroup: any = null;
  currentdate: any;
  isagentProfile: boolean = false;
  changepassword = "";
  confirmpassword = "";
  constructor(private datePipe: DatePipe, private events: Events, public loadingCtrl: LoadingController, public camera: Camera, private file: File, public actionSheetCtrl: ActionSheetController,
    private fileOpener: FileOpener, public navCtrl: NavController, public navParams: NavParams, private socialSharing: SocialSharing,
    private screenshot: Screenshot, private modalCtrl: ModalController, private alertCtrl: AlertController, private apiProvider: ApiProvider, private actionsheetCtrl: ActionSheetController) {
    this.pet = 'contact'
    this.shareImageNi = "https://lh3.googleusercontent.com/8c4SpecjfcnCdfq2PXTwS7vvjPmrOa-lgbcczv6RBRF-6fgYv7-qCrNEW5owqQRPx15FesYOt3oqJrQJTmk0XZoR4WGEc3UGGbZgt7GvPKOd_pW4_Cbd9yqiHY9mxoHAkr5m-coUo47lsSy484J4kINWBrR3YaXClG_KRLvYDMH5vjipCJsTlh8-1Eg5z-IMON0yW9dwL0C42FPDTJ5pQIE2ilZ7J4CYGSo14XDw87zdZ7GrkrLtuESlupo2rzAX80zaZ4ER-S-o8fhHwvLYNrrYrfrJMCBjduqziJxvuBnB5fMSkn8BUI9JuIcqq9Hp5J2aEwIrb1xQUpW8bbC0o2Y8hVUv2yECJ8F4jieEg5EQaz--sPxjogAEgybsaGS7QJK6yphIm59ulIQRUmcwOEf5oqMHwXUrYfaW4v-hia_9h4vuNWoUOksNstaJa22PVRbZGIZLdFdfPYE9ekVyFvUxqsZ9Ft6pFAXdkD3UX7GaKujky6QFNJDqkCef8Tu0vXQFPycxmIdm4spMgKy6NIc92_p6AQo_7AYrv7pI_vtUL4-Sh6HtQ09o6g0GbprKCnforqQyHWsAOdVQ5M6zjOrh6dNAuxFTl4MHIV8=w353-h588-no";
    this.siteName = "http://ionicprogrammer.blogspot.in/";
    this.getuserprofieldata();
    this.viewpackagedeatils();
    var myDate: String = new Date().toISOString();
    this.currentdate = this.datePipe.transform(myDate, 'yyyy-MM-dd');
    console.log(this.currentdate);
    var mainUsr = JSON.parse(localStorage.getItem('main_usr_data'));
    var mainUsrId: any;
    if (mainUsr) {
      this.isagentProfile = true;
    }

  }

  ngAfterViewInit(): void {
    // let name = 'Faizulla',
    //   surname = 'Molla',
    //   org = 'Google',
    //   url = 'www.google.com',
    //   email = 'faizu@gmail.com',
    //   tel = '000 111 222';

    this.vCardInfo = `BEGIN:VCARD
VERSION:3.0
N:${this.profiledata.usr_nm};
ORG:${this.profiledata.usr_role}
EMAIL:${this.profiledata.usr_email}
TEL;TYPE=voice,work,oref:${this.profiledata.usr_ph}
END:VCARD
`
    // URL:${url}
    this.userInputElementt = this.userInputtViewChild.nativeElement;
  }

  // public vCardString = VCardFormatter.getVCardAsString(this.vCard);
  ionViewDidLoad() {
    console.log('ionViewDidLoad ProfilePage');

  }
  updatepassword() {
    if (this.confirmpassword.length > 0) {
      if (this.confirmpassword !== this.changepassword) {
        const alert = this.alertCtrl.create({
          cssClass: 'my-custom-class',
          title: "ERROR",
          subTitle: 'Password Doesnt Match',
          mode: 'ios',
          buttons: ['OK']
        });
        alert.present();
      } else {
        var usr_dt = JSON.parse(localStorage.getItem('user_data'));

        const data = {
          'upass': this.changepassword,
          'u_id': usr_dt[0].usr_id
        }
        console.log(data);
        this.apiProvider.changepassworduser(data).subscribe((res: any) => {
          console.log(res.data)
          if (res.status == 200) {
            this.changepassword = "";
            this.confirmpassword = "";
            const alert = this.alertCtrl.create({
              cssClass: 'my-custom-class',
              title: 'Successful ',
              subTitle: 'Password Changed',
              mode: 'ios',
              buttons: ['OK']
            });
            alert.present();
          } else {
            const alert = this.alertCtrl.create({
              cssClass: 'my-custom-class',
              title: res.message,
              subTitle: 'Please contact admin',
              mode: 'ios',
              buttons: ['OK']
            });
            alert.present();
          }
        }, er => {
          console.log(er);
        })
      }
    }

  }

  // loadImageFromDevice1(event, id) {
  //   console.log(id);
  //   const reader = new FileReader();
  //   reader.onload = () => {
  //     this.profiledata.usr_img = reader.result as string;
  //     console.log(this.profiledata.usr_img);
  //     const country = JSON.parse(localStorage.getItem('user_data'));
  //     var data = {
  //       'usr_id': country[0].usr_id,
  //       'usr_img': this.profiledata.usr_img
  //     }
  //     this.apiProvider.presentLoadingIos();
  //     this.apiProvider.updateprofileImage(data).subscribe((res) => {
  //       var x = [];
  //       x.push(res);
  //       if (x[0].status == 200) {
  //         alert('Succeffully Profile Image Updated')
  //         this.apiProvider.loading.dismiss();
  //       }
  //     })
  //   }
  //   reader.readAsDataURL((event.target as HTMLInputElement).files[0])

  // };

  goBack() {
    this.navCtrl.setRoot('HomePage');
  }

  goPrevious() {
    this.navCtrl.setRoot('AgenthomePage');
  }
  gotopage(id) {
    if (id == 0) {
      this.navCtrl.setRoot('HomePage');
    } else if (id == 1) {
      this.navCtrl.push('StartLeadsPage');
    } else if (id == 2) {
      this.navCtrl.push('ToolkitPage');
    } else if (id == 3) {
      this.navCtrl.push('ChatChaptersPage');
    } else if (id == 4) {
      this.navCtrl.push('LeadsTabsPage');
    }

  }

  reset() {
    var self = this;
    setTimeout(function () {
      self.state = false;
    }, 1000);
  }
  process() {
    const qrcode = QRCode;
    const self = this;
    qrcode.toDataURL(self.vCardDAta, { errorCorrectionLevel: 'H' }, function (err, url) {
      self.generated = url;
      console.log(self.generated);

    })
  }
  displayQrCode() {
    return this.generated !== '';
  }
  screenShot() {
    this.screenshot.save('jpg', 80, 'myscreenshot.jpg').then(res => {
      console.log(res)
      this.screen = res.filePath;
      console.log(this.screen);
      this.DownloadProfile()
      this.state = true;
      // this.reset();
      this.screenShotURI()
    });
  }

  screenShotURI() {
    this.screenshot.URI(80).then(res => {
      console.log('res', res)
      this.screen = res.URI;
      console.log(this.screen);
      const country = JSON.parse(localStorage.getItem('user_data'));
      var mainUsr = JSON.parse(localStorage.getItem('main_usr_data'));
      var mainUsrId: any;
      if (mainUsr) {
        mainUsrId = mainUsr.main_usr_id
      } else {
        mainUsrId = country[0].usr_id
      }

      var data = {
        'usr_id': mainUsrId,
        'image': this.screen
      }
      const options = {
        message: null, // not supported on some apps (Facebook, Instagram)
        subject: null, // fi. for email
        files: [this.screen] // an array of filenames either locally or remotely
      };
      this.shared = false;
      this.socialSharing.shareWithOptions(options)
        .catch(error => {
          // Handle the error!!
          console.log(error);
        })
      console.log(data)
      this.state = true;
      // this.reset();
    });
  }

  DownloadProfile() {
    let imageName = "myscreenshot.jpg";
    const ROOT_DIRECTORY = 'file:///sdcard//';
    const downloadFolderName = 'tempDownloadFolder';
    // this.socialSharing.share("Message","Subject", this.file.externalRootDirectory + downloadFolderName + "/" + imageName, imageName)
    // .then((entries) => {
    //   console.log('success ' + JSON.stringify(entries));
    // })
    // .catch((error) => {
    //   alert('error ' + JSON.stringify(error));
    // });
    //Create a folder in memory location
    this.file.createDir(ROOT_DIRECTORY, downloadFolderName, true)
      .then((entries) => {
        console.log(this.file, this.file.applicationDirectory, this.file.applicationStorageDirectory, this.file.cacheDirectory, this.file.documentsDirectory, this.file.externalApplicationStorageDirectory, this.file.externalDataDirectory, this.file.externalRootDirectory);

        //Copy our asset/img/FreakyJolly.jpg to folder we created
        this.file.copyFile(this.file.externalRootDirectory + "Pictures/", imageName, ROOT_DIRECTORY + downloadFolderName + '//', imageName)
          .then((entries) => {

            //Common sharing event will open all available application to share
            this.socialSharing.share("Message", "Subject", ROOT_DIRECTORY + downloadFolderName + "/" + imageName, imageName)
              .then((entries) => {
                console.log('success ' + JSON.stringify(entries));
              })
              .catch((error) => {
                alert('error ' + JSON.stringify(error));
              });
          })
          .catch((error) => {
            alert('error ' + JSON.stringify(error));
          });
      })
      .catch((error) => {
        alert('error ' + JSON.stringify(error));
      });
  }

  ShareProfile() {
    this.shared = true;
    this.hideind = true;
    console.log(this.shared);
    this.screenShot()

  }

  gotoSearchPage() {
    this.navCtrl.push('SearchPage');
  }

  LogOut() {
    this.logOutAlert();
  }

  addDetails() {
    var mainUsr = JSON.parse(localStorage.getItem('main_usr_data'));
    var mainUsrId: any;
    if (mainUsr) {
      mainUsrId = mainUsr.main_usr_id
      return
    }

    let modal = this.modalCtrl.create(ScreenModel);
    modal.present();
  }

  ashish(data: any) {
    var mainUsr = JSON.parse(localStorage.getItem('main_usr_data'));
    var mainUsrId: any;
    if (mainUsr) {
      mainUsrId = mainUsr.main_usr_id
      return
    }
    var deleteHandler = () => {
      const email = this.profiledata.usr_email;
      const alertOptions = {
        cssClass: 'my-custom-class',
        title: 'Delete Account Alert !',
        mode: 'ios',
        subTitle: 'Deleted successfully',
        buttons: [{
          text: 'Ok',
          handler: () => {
            localStorage.clear();
            // window.location.reload();
            this.navCtrl.push('SignupPage');
          }
        }]
      };

      this.apiProvider.deleteUser({ 'usr_email': email }).subscribe((res) => {
        console.log(res);
      });
      const alert2 = this.alertCtrl.create(alertOptions);
      alert2.present();
    };
    console.log('tcfygvuhbjii')
    const alert = this.alertCtrl.create({
      cssClass: 'my-custom-class',
      title: 'Delete Account Alert !',
      mode: 'ios',
      subTitle: 'We are sad to know that you want to delete your account , kindly please confirm your choice to delete your account permanently from our records , please note you can only re login into our application again as new member by re registering  ',
      buttons: [{ text: 'Do not delete & go back', role: 'confirm', }, { text: 'Confirm Delete', role: 'delete', handler: deleteHandler, }],
    });
    alert.present();
  }

  getuserprofieldata() {
    debugger
    var country = JSON.parse(localStorage.getItem('user_data'));
    var mainUsr = JSON.parse(localStorage.getItem('main_usr_data'));
    var mainUsrId: any;
    if (mainUsr) {
      mainUsrId = mainUsr.main_usr_id
    } else {
      mainUsrId = country[0].usr_id
    }


    console.log(country);
    var data = {
      'usr_id': mainUsrId
    }
    this.apiProvider.userprofiledata(data).subscribe((res) => {
      console.log(res);

      var x = [];
      x.push(res);
      this.profiledata = x[0].data[0];
      console.log(this.profiledata);
      // this.events.publish('user:signedIn', this.profiledata);
    })
  }

  presentActionSheet() {
    const actionSheet = this.actionSheetCtrl.create({

      title: 'Take a Picture',

      buttons: [
        {
          text: 'Camera',
          role: 'destructive',
          icon: 'md-camera',
          handler: () => {
            console.log('Destructive clicked');
            const options: CameraOptions = {
              quality: 70,
              destinationType: this.camera.DestinationType.DATA_URL,
              encodingType: this.camera.EncodingType.JPEG,
              mediaType: this.camera.MediaType.PICTURE,
              correctOrientation: true
            }
            this.camera.getPicture(options).then((imageData) => {
              this.profiledata.usr_img = 'data:image/jpeg;base64,' + imageData;
              const country = JSON.parse(localStorage.getItem('user_data'));
              var mainUsr = JSON.parse(localStorage.getItem('main_usr_data'));
              var mainUsrId: any;
              if (mainUsr) {
                mainUsrId = mainUsr.main_usr_id
              } else {
                mainUsrId = country[0].usr_id
              }
              var data = {
                'usr_id': mainUsrId,
                'usr_img': this.profiledata.usr_img
              }
              this.presentLoadingIos();
              this.apiProvider.updateprofileImage(data).subscribe((res) => {
                var x = [];
                x.push(res);
                if (x[0].status == 200) {
                  this.loading.dismiss();
                  this.viewpackagedeatils();
                  this.getuserprofieldata();
                  const alert = this.alertCtrl.create({
                    cssClass: 'my-custom-class',
                    subTitle: 'Succeffully Profile Image Updated',
                    mode: 'ios',
                    buttons: ['OK']
                  });
                  alert.present();
                }
              })
            }, (err) => {
              // Handle error
            });
          }
        }, {
          text: 'Gallery',
          icon: 'md-image',
          handler: () => {
            console.log('Archive clicked');
            const options: CameraOptions = {
              quality: 70,
              destinationType: this.camera.DestinationType.DATA_URL,
              encodingType: this.camera.EncodingType.JPEG,
              mediaType: this.camera.MediaType.PICTURE,
              correctOrientation: true
            }
            this.camera.getPicture(options).then((imageData) => {
              this.profiledata.usr_img = 'data:image/jpeg;base64,' + imageData;
              const country = JSON.parse(localStorage.getItem('user_data'));
              var mainUsr = JSON.parse(localStorage.getItem('main_usr_data'));
              var mainUsrId: any;
              if (mainUsr) {
                mainUsrId = mainUsr.main_usr_id
              } else {
                mainUsrId = country[0].usr_id
              }
              var data = {
                'usr_id': mainUsrId,
                'usr_img': this.profiledata.usr_img
              }
              this.presentLoadingIos();
              this.apiProvider.updateprofileImage(data).subscribe((res) => {
                var x = [];
                x.push(res);
                if (x[0].status == 200) {
                  this.loading.dismiss();
                  this.viewpackagedeatils();
                  this.getuserprofieldata();
                  const alert = this.alertCtrl.create({
                    cssClass: 'my-custom-class',
                    subTitle: 'Succeffully Profile Image Updated',
                    mode: 'ios',
                    buttons: ['OK']
                  });
                  alert.present();
                }
              })
            }, (err) => {
              // Handle error
            });
          }
        }, {
          text: 'Cancel',
          role: 'cancel',

          handler: () => {
            console.log('Cancel clicked');
          }
        }
      ]
    });
    actionSheet.present();
  }
  presentLoadingIos() {
    this.loading = this.loadingCtrl.create({
      spinner: 'ios',
      content: 'Please wait...'
    });
    this.loading.present();
  }

  // loadImageActionSheet1(event, id) {
  //   console.log(id)
  //   const actionSheet = this.actionsheetCtrl.create({
  //     title: 'Albums',
  //     buttons: [{
  //       text: 'Gallery',
  //       icon: 'trash-solid',
  //       handler: () => {
  //         this.userInputElementt.click();
  //       }
  //     }, {
  //       text: 'Close',
  //       icon: 'close',
  //       role: 'cancel'
  //     }]
  //   });
  //   actionSheet.present();

  // };

  logOutAlert() {
    const alert = this.alertCtrl.create({
      cssClass: 'my-custom-class',
      subTitle: 'Are you sure you want to Logout?',
      buttons: [{
        text: 'No',
        handler: () => {
        }
      }, {
        text: 'Ok',
        handler: () => {
          localStorage.clear();
          window.location.reload();
        }
      },
      ]
    });
    alert.present();
  }

  // get pakage deatils start
  viewpackagedeatils() {
    this.hideind = true;
    const country = JSON.parse(localStorage.getItem('user_data'));
    var mainUsr = JSON.parse(localStorage.getItem('main_usr_data'));
    var mainUsrId: any;
    if (mainUsr) {
      mainUsrId = mainUsr.main_usr_id
    } else {
      mainUsrId = country[0].usr_id
    }
    var data = {
      'user_id': mainUsrId
    }
    this.apiProvider.getviewpackagedeatils(data).subscribe((res) => {
      console.log(res);

      var x = [];
      x.push(res);
      this.pakagedetails = x[0].data;
      console.log(this.pakagedetails);
      var userData = JSON.parse(localStorage.getItem('user_data'));
      var mainUsr = JSON.parse(localStorage.getItem('main_usr_data'));
      var mainUsrId: any;
      if (mainUsr) {
        mainUsrId = mainUsr.main_usr_id
        return
      } else {
        mainUsrId = country[0].usr_id
      }
      var usrData = userData[0].reportdata.filter(word => word.chapterend >= this.currentdate);
      console.log(usrData);
      if (usrData.length != 0) {
        console.log(usrData);
        var array3 = usrData.map(obj => obj.package_indicator).sort()
        console.log(array3);
        this.profilepackage = array3[0];
      } else {
        this.profilepackage = 0;
      }
      var reportdata = [];
      var resdataval = [];

      if (x[0].data.length > 0) {
        reportdata = x[0].data.sort();
        console.log(reportdata);
        var i = 0;
        var j = -1;
        for (i = 0; i < reportdata.length; i++) {
          // if (i == 0 || (reportdata[i].membership_id != reportdata[i - 1].membership_id && i > 0)) {
          //   j++;
          //   resdataval[j] = {};
          //   resdataval[j].membership_id = reportdata[i].membership_id;
          //   resdataval[j].membership_name = reportdata[i].membership_name;
          //   resdataval[j].membership_start_date = reportdata[i].membership_start_date;
          //   resdataval[j].membership_end_date = reportdata[i].membership_end_date;
          //   resdataval[j].usr_credits = reportdata[i].usr_credits;
          //   resdataval[j].ammount = reportdata[i].ammount;
          //   resdataval[j].usd_ammount = reportdata[i].usd_ammount;
          //   resdataval[j].reportdata = [];
          //   resdataval[j].reportdata.push({
          //     "chapter_id": reportdata[i].chapter_id,
          //     "chapter_nm": reportdata[i].chapter_nm,
          //     "parent_membership_id": reportdata[i].parent_membership_id,
          //     "member_ship_id": reportdata[i].member_ship_id,
          //   });
          // } else if (reportdata[i].membership_id === reportdata[i - 1].membership_id) {
          //   resdataval[j].reportdata.push({
          //     "chapter_id": reportdata[i].chapter_id,
          //     "chapter_nm": reportdata[i].chapter_nm,
          //     "parent_membership_id": reportdata[i].parent_membership_id,
          //     "member_ship_id": reportdata[i].member_ship_id,
          //   });
          // }
          if (i == 0 || (reportdata[i].membership_id != reportdata[i - 1].membership_id && i > 0)) {
            j++;
            resdataval[j] = {};
            resdataval[j].usr_id = reportdata[i].usr_id;
            resdataval[j].usr_state = reportdata[i].usr_state;
            resdataval[j].usr_ph = reportdata[i].usr_ph;
            resdataval[j].usr_password = reportdata[i].usr_password;
            resdataval[j].usr_nm = reportdata[i].usr_nm;
            resdataval[j].usr_email = reportdata[i].usr_email;
            resdataval[j].signupdate = reportdata[i].signupdate;
            resdataval[j].usr_img = reportdata[i].usr_img;
            resdataval[j].usr_district = reportdata[i].usr_district;
            resdataval[j].usr_country = reportdata[i].usr_country;
            resdataval[j].organisation = reportdata[i].organisation;
            resdataval[j].usr_continent = reportdata[i].usr_continent;
            resdataval[j].usr_address = reportdata[i].usr_address;
            resdataval[j].parentstart = reportdata[i].parentstart;
            resdataval[j].parentend = reportdata[i].parentend;
            resdataval[j].premium_payment_indicator = reportdata[i].premium_payment_indicator;
            resdataval[j].membership_type_indicator = reportdata[i].membership_type_indicator;
            resdataval[j].country_nm = reportdata[i].country_nm;
            resdataval[j].mail_verification_ind = reportdata[i].mail_verification_ind;

            resdataval[j].membership_id = reportdata[i].membership_id;
            resdataval[j].membership_name = reportdata[i].membership_name;
            resdataval[j].membership_start_date = reportdata[i].membership_start_date;
            resdataval[j].membership_end_date = reportdata[i].membership_end_date;
            resdataval[j].usr_credits = reportdata[i].usr_credits;
            resdataval[j].ammount = reportdata[i].ammount;
            resdataval[j].usd_ammount = reportdata[i].usd_ammount;
            resdataval[j].reportdata = [];
            resdataval[j].reportdata.push({
              "purchase_chapter_id": reportdata[i].purchase_chapter_id,
              "parent_membership_id": reportdata[i].parent_membership_id,
              "memberstart": reportdata[i].memberstart,
              "package_indicator": reportdata[i].package_indicator,
              "memberend": reportdata[i].memberend,
              "chapterend": reportdata[i].chapterend,
              "chapterstart": reportdata[i].chapterstart,
              "chapter_nm": reportdata[i].chapter_nm,
              'chapter_id': reportdata[i].chapter_id,
              'membership_id': reportdata[i].membership_id,
              'section_id': reportdata[i].section_id,
              'usr_credits': reportdata[i].usr_credits
            });
          } else if (reportdata[i].membership_id === reportdata[i - 1].membership_id) {
            resdataval[j].reportdata.push({
              "purchase_chapter_id": reportdata[i].purchase_chapter_id,
              "parent_membership_id": reportdata[i].parent_membership_id,
              "package_indicator": reportdata[i].package_indicator,
              "memberstart": reportdata[i].memberstart,
              "memberend": reportdata[i].memberend,
              "chapterend": reportdata[i].chapterend,
              "chapterstart": reportdata[i].chapterstart,
              "chapter_nm": reportdata[i].chapter_nm,
              'chapter_id': reportdata[i].chapter_id,
              'membership_id': reportdata[i].membership_id,
              'section_id': reportdata[i].section_id,
              'usr_credits': reportdata[i].usr_credits
            });
          }
        }
      }
      this.pakagechapterdetails = resdataval;
      console.log(
        this.pakagechapterdetails
      );

      this.events.publish('user:signedIn', this.pakagechapterdetails);
      // for (var i=0;i<this.pakagechapterdetails.length;i++){
      //   this.totalcr=this.totalcr + this.pakagechapterdetails[i].usr_credits
      // }
      this.totalcr = this.pakagechapterdetails.reduce((sum, item) => sum + item.usr_credits, 0);
      console.log(this.pakagechapterdetails, this.totalcr);

    });
  }
  //get pakage details end
  // toggleGroup(group) {
  //   console.log(group);
  //   if (this.isGroupShown(group)) {
  //     this.shownGroup = null;
  //   } else {
  //     this.shownGroup = group;
  //   }
  // };
  // isGroupShown(group) {
  //   return this.shownGroup === group;
  // };
  toggleGroup(group) {
    console.log(group);
    if (this.isGroupShown(group)) {
      // var cnt=group;
      console.log("If");
      this.highlighted = -1;
      // this.variation=-1;
      this.shownGroup = null;

    } else {
      console.log("Else");
      this.highlighted = group;
      // this.variation=-1;
      this.shownGroup = group;
    }
  };
  isGroupShown(group) {
    // console.log(group);
    return this.shownGroup === group;
  };
  upgradesubscription() {
    this.navCtrl.push('SubscriptionPage')
  }
  goshareBack() {
    console.log('hitted');
    this.navCtrl.setRoot('ProfilePage');

  }
}




// PAYMENT PAGE START
@Component({
  selector: 'page-screen',
  templateUrl: 'screen.html',
})
export class ScreenModel {
  userDetailsForm: FormGroup;
  ProductData: any[] = [];
  submitData: any = {};
  payData: any = {};
  dateNow: Date = new Date();
  Expirydate: any;
  use: boolean = false;
  alert: any;
  myphoto: any = '';
  myphotos: any = '';
  imagearry: any = [];
  profiledata: any = []; profile_pic: any; company_pic: any;
  constructor(public navCtrl: NavController, public navParams: NavParams, public formBuilder: FormBuilder,
    public camera: Camera, private apiProvider: ApiProvider, private navParam: NavParams, private alertCtrl: AlertController, public view: ViewController,) {
    this.getprofidata();
    this.userDetailsForm = this.formBuilder.group({
      c_mail: ['', [Validators.required, Validators.email]],
      c_name: ['', [Validators.required]],
      c_numb: [, [Validators.required]],
      c_address: ['', [Validators.required]],
      c_export: ['', [Validators.required]],
      c_import: ['', [Validators.required]],
    })


  }
  get userDetailsFormControl() {
    return this.userDetailsForm.controls;
  }
  getprofidata() {
    var country = JSON.parse(localStorage.getItem('user_data'));
    var mainUsr = JSON.parse(localStorage.getItem('main_usr_data'));
    var mainUsrId: any;
    if (mainUsr) {
      mainUsrId = mainUsr.main_usr_id
    } else {
      mainUsrId = country[0].usr_id
    }
    console.log(country);
    var data = {
      'usr_id': mainUsrId
    }
    this.apiProvider.userprofiledata(data).subscribe((res) => {
      console.log(res);

      var x = [];
      x.push(res);
      this.profiledata = x[0].data[0];
      this.userDetailsForm.patchValue({
        c_mail: this.profiledata.usr_email,
        c_name: this.profiledata.usr_nm,
        c_numb: this.profiledata.usr_ph,
        c_address: this.profiledata.usr_address,
        c_export: this.profiledata.c_export,
        c_import: this.profiledata.c_import,
      });
    })
  }

  takePhoto(event, id) {
    const reader = new FileReader();
    reader.onload = () => {
      var imageData = reader.result as string;
      if (id == 1) {
        this.profile_pic = imageData;
        this.myphoto = 'data:image/jpeg;base64,' + imageData;
      } else {
        this.myphoto = 'data:image/jpeg;base64,' + imageData;
        this.company_pic = imageData;
      }
      if (this.imagearry.length <= 1) {
        this.imagearry.push({ 'image': this.myphoto, "ind": id });
        console.log(this.imagearry);
      } else {
        alert('Images Uploaded')
      }
    }
    reader.readAsDataURL((event.target as HTMLInputElement).files[0])



    // this.alertt = 1;
    // var idk = id
    // this.alert = this.alertCtrl.create({
    //   cssClass: 'custom-alert',
    //   title: 'Choose Upload Option',
    //   buttons: [
    //     {
    //       text: 'Choose file',
    //       handler: () => {
    //         const options: CameraOptions = {
    //           quality: 100,
    //           destinationType: this.camera.DestinationType.DATA_URL,
    //           sourceType: this.camera.PictureSourceType.PHOTOLIBRARY,
    //           saveToPhotoAlbum: false
    //         }
    //         this.camera.getPicture(options).then((imageData) => {
    //           if (idk == 1) {
    //             this.myphotos = 'data:image/jpeg;base64,' + imageData;
    //           } else {
    //             this.myphoto = 'data:image/jpeg;base64,' + imageData;
    //           }
    //           //start
    //           if (this.imagearry.length <= 2) {
    //             this.imagearry.push({ 'image': this.myphoto });
    //           } else {
    //             this.showAlertimage();
    //           }
    //           //end
    //         }, (err) => {
    //           // Handle error
    //         });
    //       }
    //     },
    //     {
    //       text: 'Camera',
    //       handler: () => {
    //         const options: CameraOptions = {
    //           quality: 70,
    //           destinationType: this.camera.DestinationType.DATA_URL,
    //           encodingType: this.camera.EncodingType.JPEG,
    //           mediaType: this.camera.MediaType.PICTURE,
    //           sourceType: this.camera.PictureSourceType.CAMERA
    //         }
    //         this.camera.getPicture(options).then((imageData) => {
    //           if (idk == 1) {
    //             this.myphotos = 'data:image/jpeg;base64,' + imageData;
    //           } else {
    //             this.myphoto = 'data:image/jpeg;base64,' + imageData;
    //           }
    //           if (this.imagearry.length <= 2) {
    //             this.imagearry.push({ 'image': this.myphoto });
    //           } else {
    //             this.showAlertimage();
    //           }
    //         }, (err) => {
    //           // Handle error
    //         });
    //       }
    //     },
    //     {
    //       text: 'Close',
    //       cssClass: 'secondary',
    //       handler: () => {
    //         console.log('Cancel clicked');
    //       }
    //     },
    //   ]
    // });
    // this.alert.present();
  }


  Deleteimage(data) {
    var index = this.imagearry.indexOf(data)
    this.imagearry.splice(index, 1);
    this.myphoto = '';
  }


  showAlertimage() {
    const alert = this.alertCtrl.create({
      // title: '4 Images Only',
      cssClass: 'my-custom-class',
      subTitle: 'Do You want to select another image',
      buttons: [{
        text: 'No',
        handler: () => {
        }
      }, {
        text: 'Yes',
        handler: () => {
          // this.myphoto = '';
          // this.imagearry = [];
          // this.takePhoto();
        }
      },]

    });
    alert.present();
  }
  submitDetails() {
    var country = JSON.parse(localStorage.getItem('user_data'));
    var mainUsr = JSON.parse(localStorage.getItem('main_usr_data'));
    var mainUsrId: any;
    if (mainUsr) {
      mainUsrId = mainUsr.main_usr_id
    } else {
      mainUsrId = country[0].usr_id
    }
    console.log(country);
    this.userDetailsForm.value.usr_id = mainUsrId;
    this.userDetailsForm.value.profile_pic = this.profile_pic;
    this.userDetailsForm.value.company_pic = this.company_pic;
    this.apiProvider.userDetailsUpdate(this.userDetailsForm.value).subscribe((res: any) => {
      console.log(res)
      var x = [];
      x.push(res);
      if (x[0].status == 200) {
        const alert = this.alertCtrl.create({
          cssClass: 'my-custom-class',
          title: 'Profile Details',
          mode: 'ios',
          subTitle: 'Updated Succesfuly',
          buttons: ['OK']
        });
        alert.present();
        this.view.dismiss();
        this.getprofidata();
        location.reload();
      }

    }, er => {
      console.log(er);
    })
  }



}


// WEBPACK FOOTER //
// ./src/pages/profile/profile.ts